<template>
  <div class="wp_img">
    <!-- 展览 -->
    <div class="preview">
      <div class="banner-wrapper" ref="zhanlan">
        <div class="slide-banner-content">
          <div v-for="(item,i) in zhanlan" v-bind:key="i" class="slide-page bottomIn"
               :class="{'active': i === currentPageIndex.zhanlan }">
            <img :src="item" Preview="zhanlan"/>
          </div>
        </div>
      </div>
      <img class="bg" :src="bgs[0]"/>
    </div>
    <!-- 交流 -->
    <div class="preview">
      <div class="banner-wrapper" ref="jiaoliu">
        <div class="slide-banner-content">
          <div v-for="(item,i) in jiaoliu" v-bind:key="i" class="slide-page bottomIn"
               :class="{'active': i == currentPageIndex.jiaoliu }">
            <img :src="item" Preview="jiaoliu"/>
          </div>
        </div>
      </div>
      <img class="bg" :src="bgs[1]"/>
    </div>
    <!-- 联动 -->
    <div class="preview">
      <div class="v-waterfall-content" ref="liandong">
        <div class="v-waterfall-group">
          <div v-for="(item,i) in liandong" v-bind:key="i" class="v-waterfall-item">
            <img v-lazy="item" Preview="liandong" preview-text="线上线下联动"/>
          </div>
        </div>
      </div>
      <img class="bg" :src="bgs[2]"/>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Slide from '@better-scroll/slide'

BScroll.use(Slide)

export default {
  name: "CeHua",
  data() {
    return {
      zhanlan: [
        require("../assets/cehua/zhanlan/1.jpg"),
        require("../assets/cehua/zhanlan/2.jpg"),
        require("../assets/cehua/zhanlan/3.jpg"),
        require("../assets/cehua/zhanlan/4.jpg"),
        require("../assets/cehua/zhanlan/5.jpg"),
        require("../assets/cehua/zhanlan/6.jpg"),
        require("../assets/cehua/zhanlan/7.jpg"),
        require("../assets/cehua/zhanlan/8.jpg")
      ],
      jiaoliu: [
        require("../assets/cehua/jiaoliu/1.jpg"),
        require("../assets/cehua/jiaoliu/2.jpg"),
        require("../assets/cehua/jiaoliu/3.jpg"),
        require("../assets/cehua/jiaoliu/4.jpg"),
        require("../assets/cehua/jiaoliu/5.jpg"),
        require("../assets/cehua/jiaoliu/6.jpg"),
        require("../assets/cehua/jiaoliu/7.jpg"),
        require("../assets/cehua/jiaoliu/8.jpg"),
        require("../assets/cehua/jiaoliu/9.jpg"),
        require("../assets/cehua/jiaoliu/10.jpg"),
        require("../assets/cehua/jiaoliu/12.jpg"),
      ],
      liandong: [
        require("../assets/cehua/liandong/4.jpg"),
        require("../assets/cehua/liandong/5.jpg"),
        require("../assets/cehua/liandong/6.jpg"),
        require("../assets/cehua/liandong/7.jpg"),
        require("../assets/cehua/liandong/8.png"),
        require("../assets/cehua/liandong/9.png"),
        require("../assets/cehua/liandong/2.jpg"),
        require("../assets/cehua/liandong/3.jpg"),
        require("../assets/cehua/liandong/10.png"),
        require("../assets/cehua/liandong/11.png"),
        require("../assets/cehua/liandong/12.jpg"),
        require("../assets/cehua/liandong/13.jpg"),
        require("../assets/cehua/liandong/14.png"),
        require("../assets/cehua/liandong/15.png"),
        require("../assets/cehua/liandong/16.jpg"),
        require("../assets/cehua/liandong/17.png"),
        require("../assets/cehua/liandong/1.jpg"),
      ],
      bgs: [
        require("../assets/23.jpg"),
        require("../assets/24.jpg"),
        require("../assets/25.jpg"),
      ],
      options: {
        scrollX: true,
        scrollY: false,
        slide: true,
        useTransition: true,
        momentum: false,
        bounce: false,
        stopPropagation: true,
        probeType: 1,
        click: true
      },
      currentPageIndex: {}
    };
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.slide.destroy()
  },
  methods: {
    init() {
      this.slide_zhanlan = new BScroll(this.$refs.zhanlan, this.options)
      this.slide_jiaoliu = new BScroll(this.$refs.jiaoliu, this.options)

      this.slide_zhanlan.on('slideWillChange', (page) => {
        this.currentPageIndex.zhanlan = page.pageX
      })
      this.slide_jiaoliu.on('slideWillChange', (page) => {
        this.currentPageIndex.jiaoliu = page.pageX
      })

      this.currentPageIndex = {
        zhanlan: 0,
        jiaoliu: 0
      }
    }
  }
};
</script>

<style scoped lang="less">
.preview {
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;

  .bg {
    width: 100%;
  }

  .banner-wrapper {
    position: absolute;
    width: 6rem;
    left: calc(50% - 3rem);
    top: 3rem;


    .slide-banner-content {
      height: 3.375rem;
      white-space: nowrap;

      .slide-page {
        display: inline-block;
        width: 100%;
        height: 3.375rem;
        box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.4);
        transition: transform .5s;

        &.active {
          transform: scale(1.1);
          z-index: 15;
        }

        img {
          width: 100%;
        }
      }
    }
  }

  .v-waterfall-content {
    position: absolute;
    width: 100%;
    height: 8rem;
    overflow: hidden;
    left: 0;
    top: 2rem;
    padding: .5rem 0;

    .v-waterfall-group {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .v-waterfall-item {
        margin: .14rem;
        width: 3.2rem;
        height: 1.9rem;
        box-shadow: 5px 5px 20px 0 rgba(0, 0, 0, 0.4);
        overflow: hidden;

        img {
          width: 3.5rem;
          transform: scale(1.3);
          object-fit: fill;
        }
      }
    }


  }
}
</style>